export default class FormacaoInscricoesController {
    constructor($q, $filter, $state, UIService, AuthenticationService, AuthorizationService, FormacaoInscricao, FormacaoEdicao, FormacaoInscricaoEstado, CoreFormaPagamento, FormacaoEmpresa) {
        this.$q = $q;
        this.$filter = $filter;
        this.$state = $state;
        this.UI = UIService;
        this.user = AuthenticationService.getUser();
        this.AuthorizationService = AuthorizationService;
        this.FormacaoInscricao = FormacaoInscricao;
        this.FormacaoEdicao = FormacaoEdicao;
        this.FormacaoInscricaoEstado = FormacaoInscricaoEstado;
        this.CoreFormaPagamento = CoreFormaPagamento;
        this.FormacaoEmpresa = FormacaoEmpresa;
        // If loadData() finished or not
        this.dataLoaded = false;
        this.simnao = [{ name: "Sim", designacao: "Sim", value: 1 }, { name: "Não", designacao: "Não", value: 0 }];
        this.edicoes = [];
        this.estadosInscricao = [];
        this.formasPagamento = [];
        this.empresas = [];
        this.filtersLoaded = [1, 0, 0, 0, 0];
        this.opt = $state.params;
        // Prevent states other than 1 and 3 (would make no sense), default 1
        if (this.opt.state && this.opt.state !== 1 && this.opt.state !== 3) {
            this.opt.state = 1;
            this.$state.go('app.formacao.inscricoes.list', this.opt, {
                // prevent the events onStart and onSuccess from firing
                notify: false,
                // prevent reload of the current state?
                reload: true,
                // replace the last record when changing the params so you don't hit the back button and get old params
                location: 'replace',
                // inherit the current params on the url
                inherit: false
            });
        }
        this.stateId = this.opt.state;
        // Total processes for currently being displayed
        this.total = 0;
        // Default opt state - populate later when we have all states
        this.defaultOpt = {
            page: 1,
            items: 20,
            order: "id",
            sort: "desc",
            filter: undefined
        };
        this.displayColumns = [
            {
                displayName: 'ID SGI',
                name: 'id',
                visible: false,
                sortable: true,
                // width: 80
            },
            {
                displayName: 'Nome',
                name: 'formandoNome',
                visible: true,
                sortable: true,
                // width: 300
            },
            {
                displayName: 'NIF',
                name: 'formandoNif',
                visible: true,
                sortable: true,
                // width: 150
            },
            {
                displayName: 'Email',
                name: 'formandoEmail',
                visible: true,
                sortable: true,
                // width: 300
            },
            {
                displayName: 'Contacto',
                name: 'formandoTelefone',
                visible: true,
                sortable: true,
                // width: 300
            },
            {
                displayName: 'Edição do Curso',
                name: 'edicao',
                visible: true,
                sortable: true,
                // width: 300
            },
            {
                displayName: 'Estado',
                name: 'estado',
                visible: true,
                sortable: true,
                // width: 150
            },
            {
                displayName: 'Referência',
                name: 'referencia',
                visible: true,
                sortable: true,
                // width: 150
            },
            {
                displayName: 'Controlo IfThenPay',
                name: 'uid',
                visible: true,
                sortable: true,
                // width: 100
            },
            {
                displayName: 'Data de Inscrição',
                name: 'dataInscricao',
                visible: true,
                sortable: true,
                // width: 100
            },
            {
                displayName: 'Pago?',
                name: 'pago',
                visible: true,
                sortable: true,
                // width: 100
            },
            {
                displayName: 'Data de Pagamento',
                name: 'dataPagamento',
                visible: true,
                sortable: true,
                // width: 100
            },
            {
                displayName: 'Valor',
                name: 'valor',
                visible: true,
                sortable: true,
                // width: 80
            },
            {
                displayName: 'Forma Pagamento',
                name: 'formaPagamento',
                visible: true,
                sortable: true,
                // width: 100
            },
            {
                displayName: 'Inscrição Empresa',
                name: 'empresa',
                visible: true,
                sortable: true,
                // width: 300
            },
            {
                displayName: 'NIF Empresa',
                name: 'empresaNif',
                visible: true,
                sortable: true,
                // width: 300
            },
            {
                displayName: 'Observações',
                name: 'observacoes',
                visible: true,
                sortable: true,
                // width: 200
            },
            // Estado de faturação da inscrição (A3 / CR-SLD20180014-0004). Vêm do PEF
            // associado (`core_faturacao_automatica`), por relação — não há campos novos na
            // inscrição. Não são ordenáveis: `numeroFatura`/`dataFatura` são compostas no
            // `table()` a partir das duas origens do PEF e não existem como coluna de SQL,
            // pelo que um ORDER BY sobre elas rebentava a consulta.
            {
                displayName: 'Nº da Fatura',
                name: 'numeroFatura',
                visible: true,
                sortable: false,
                // width: 150
            },
            {
                displayName: 'Data da Fatura',
                name: 'dataFatura',
                visible: true,
                sortable: false,
                // width: 100
            },
        ];
        // type 's': select, 'o': plain text, 'd': date
        this.equalityFilters = [{
                val: 'a',
                name: 'Igual',
                type: 'o'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 'o'
            },
            {
                val: 'c',
                name: 'Começa por',
                type: 'o'
            },
            {
                val: 'd',
                name: 'Termina com',
                type: 'o'
            },
            {
                val: 'e',
                name: 'Contém',
                type: 'o'
            },
            {
                val: 'a',
                name: 'Igual (=)',
                type: 'd'
            },
            {
                val: 'b',
                name: 'Diferente de (≠)',
                type: 'd'
            },
            {
                val: 'c',
                name: 'Posterior a (>)',
                type: 'd'
            },
            {
                val: 'd',
                name: 'Anterior a (<)',
                type: 'd'
            },
            {
                val: 'e',
                name: 'Posterior ou igual (≥)',
                type: 'd'
            },
            {
                val: 'f',
                name: 'Anterior ou igual (≤)',
                type: 'd'
            },
            {
                val: 'a',
                name: 'Igual',
                type: 's'
            },
            {
                val: 'b',
                name: 'Diferente',
                type: 's'
            }
        ];
        this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');
        this.columns = [
            {
                id: 'FormacaoFormando.nome',
                name: 'Nome do Formando',
                type: 'o'
            },
            {
                id: 'FormacaoFormando.nif',
                name: 'NIF do Formando',
                type: 'o'
            },
            {
                id: 'FormacaoFormando.email',
                name: 'Email do Formando',
                type: 'o'
            },
            {
                id: 'FormacaoFormando.telefone',
                name: 'Contacto do Formando',
                type: 'o'
            },
            {
                id: 'FormacaoInscricao.edicaoId',
                name: 'Edição de Curso',
                type: 's',
                list: this.edicoes
            },
            {
                id: 'FormacaoInscricao.estadoId',
                name: 'Estado da Insrição',
                type: 's',
                list: this.estadosInscricao
            },
            {
                id: 'CorePagamento.referencia',
                name: 'Referência',
                type: 'o'
            },
            {
                id: 'CorePagamento.uid',
                name: 'Controlo IfThenPay',
                type: 'o'
            },
            {
                id: 'FormacaoInscricao.dataInscricao',
                name: 'Data Inscrição',
                type: 'd',
                format: "YYYY-MM-DD",
                displayFormat: "DD/MM/YYYY"
            },
            {
                id: 'CorePagamento.pago',
                name: 'Pago?',
                type: 's',
                list: this.simnao
            },
            {
                id: 'CorePagamento.pagamentoData',
                name: 'Data Pagamento',
                type: 'd',
                format: "YYYY-MM-DD",
                displayFormat: "DD/MM/YYYY"
            },
            {
                id: 'CorePagamento.valor',
                name: 'Valor',
                type: 'o'
            },
            {
                id: 'CorePagamento.formaPagamentoId',
                name: 'FormaPagamento',
                type: 's',
                list: this.formasPagamento
            },
            {
                id: 'FormacaoInscricaoEmpresa.empresaId',
                name: 'Inscrição Empresa',
                type: 's',
                list: this.empresas
            },
            {
                id: 'FormacaoEmpresa.nif',
                name: 'NIF Empresa',
                type: 'o'
            },
            {
                id: 'CorePagamento.observacoes',
                name: 'Observações',
                type: 'o'
            }
        ];
        // Find relevant displayColumns from local storage
        if (localStorage.getItem('FormacaoInscricoesDisplayColumns')) {
            let cols = JSON.parse(localStorage.getItem('FormacaoInscricoesDisplayColumns'));
            if (cols && cols.length > 0) {
                cols.forEach(c => {
                    let i = this.displayColumns.findIndex(x => x.name === c.name);
                    if (i >= 0)
                        this.displayColumns[i].visible = c.visible;
                });
            }
        }
        this.customFilters = [];
        // Find customFilters from local storage
        if (localStorage.getItem('FormacaoInscricoesFilter')) {
            this.customFilters = JSON.parse(localStorage.getItem('FormacaoInscricoesFilter'));
        }
        // Check if something comes from the URL, replace the customFilters if so
        if (this.opt.filter) {
            this.customFilters = [];
            let filters = this.opt.filter.split(":");
            filters.forEach(filter => {
                let a = filter.split("·");
                if (a.length === 3) {
                    try {
                        let data = {
                            column: {},
                            value: {}
                        };
                        data.column.selected = this.columns.find(f => {
                            return f.id === a[0];
                        });
                        if (angular.isUndefined(data.column.selected)) {
                            throw Error();
                        }
                        this.customFilters.push(data);
                    }
                    catch (e) {
                        this.customFilters = [];
                        this.UI.addToast('Não foi possível carregar filtros');
                    }
                }
            });
            // If updated, save it to local storage
            localStorage.setItem('FormacaoInscricoesFilter', JSON.stringify(this.customFilters));
        }
        // Restore list to selected if exists
        this.customFilters.forEach(f => {
            if (f.column && f.column.selected) {
                if (f.column.selected.id === 'FormacaoInscricao.edicaoId')
                    f.column.selected.list = this.edicoes;
                if (f.column.selected.id === 'FormacaoInscricao.estadoId')
                    f.column.selected.list = this.estadosInscricao;
                if (f.column.selected.id === 'CorePagamento.pago')
                    f.column.selected.list = this.simnao;
                if (f.column.selected.id === 'CorePagamento.formaPagamentoId')
                    f.column.selected.list = this.formasPagamento;
                if (f.column.selected.id === 'FormacaoEmpresa.empresaId')
                    f.column.selected.list = this.formasPagamento;
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === 'd') {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        // Number of selected items
        this.nSelected = 0;
        this.everythingSelected = false;
        // Load the data for the filter panel (not mandatory just to look at the table)
        this.loadData();
        // Load the table data so we can see stuff even if nothing else works
        this.getInscricoes();
    }
    ;
    clearFilter = () => {
        localStorage.removeItem('FormacaoInscricoesFilter');
        this.customFilters = [];
        this.getInscricoes();
    };
    // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
    setWhereField = (data, whereObject, whereOrObject) => {
        // Check if have this entry in whereOr already
        if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
            whereOrObject.push({
                key: data.key,
                value: data.value
            });
        }
        else { // Not in OR, check if there's an entry of this key in whereObject already
            if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
                whereOrObject.push({
                    key: data.key,
                    value: whereObject[data.key]
                });
                delete whereObject[data.key];
                whereOrObject.push({
                    key: data.key,
                    value: data.value
                });
            }
            else { // It's the first entry of this key, use whereObject only
                whereObject[data.key] = data.value;
            }
        }
    };
    // Returns a whereFields object to use in table() remote methods (ativo, interacao)
    // WhereLiteral should be defined locally
    setWhereFields = (customFilters, literal, orsLiteral) => {
        let where = {};
        let whereDates = [];
        let whereNextDates = [];
        let whereLiteral = literal || {};
        let whereOrLiteral = orsLiteral || [];
        let whereOr = [];
        customFilters.forEach(f => {
            let data = {};
            data.key = f.column.selected.id;
            // Generated dates - Assuming if no . exists in field, it's always generated date
            if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
                whereNextDates.push({
                    key: data.key,
                    comp: f.values.selected.val,
                    value: f.value,
                    format: f.column.selected.format
                });
            }
            else { // All other cases where fields exist in database
                if (f.column.selected.type === 'o') {
                    data.value = f.value;
                    this.setWhereField(data, where, whereOr);
                }
                else {
                    if (f.column.selected.type === 'd') {
                        whereDates.push({
                            key: data.key,
                            comp: f.values.selected.val,
                            value: f.value,
                            format: f.column.selected.format
                        });
                    }
                    else {
                        // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
                        if (f.value.selected.id)
                            data.value = f.value.selected.id;
                        else
                            data.value = f.value.selected.value;
                        this.setWhereField(data, whereLiteral, whereOrLiteral);
                    }
                }
            }
        });
        return {
            where: where,
            whereDates: whereDates,
            whereNextDates: whereNextDates,
            whereLiteral: whereLiteral,
            whereOr: whereOr,
            whereOrLiteral: whereOrLiteral
        };
    };
    getInscricoes = () => {
        this.tableLoading = true;
        let whereFields = this.setWhereFields(this.customFilters);
        this.FormacaoInscricao.table({
            params: {
                fields: [
                    'FormacaoInscricao.id as id',
                    'FormacaoInscricao.edicaoId as edicaoId',
                    'FormacaoInscricao.estadoId as estadoId',
                    'FormacaoInscricao.dataInscricao as dataInscricao',
                    // 'edicao' comes by automatically (not declared here)
                    // Formando
                    'FormacaoFormando.id as formandoId', // For links to formando
                    'FormacaoFormando.nome as formandoNome',
                    'FormacaoFormando.nif as formandoNif',
                    'FormacaoFormando.email as formandoEmail',
                    'FormacaoFormando.telefone as formandoTelefone',
                    // Core Pagamento
                    'CorePagamento.referencia as referencia',
                    'CorePagamento.uid as uid',
                    'CorePagamento.formaPagamentoId as formaPagamentoId',
                    'CorePagamento.pago as pago',
                    'CorePagamento.pagamentoData as dataPagamento',
                    'CorePagamento.valor as valor',
                    'CorePagamento.observacoes as observacoes',
                    // Empresa
                    'FormacaoEmpresa.designacao as empresa',
                    'FormacaoEmpresa.nif as empresaNif',
                    // Extras
                    'FormacaoCurso.id as cursoId', // Used for links
                    'CoreFormaPagamento.designacao as formaPagamento',
                    'FormacaoInscricaoEstado.designacao as estado',
                    // Faturação (A3 / CR-SLD20180014-0004): duas origens porque o PEF liga-se
                    // à inscrição individual ou à inscrição de empresa; o `table()` junta-as
                    // em `numeroFatura`/`dataFatura`
                    'CoreFaturacaoAutomatica.documentoErp as numeroFaturaIndividual',
                    'CoreFaturacaoAutomatica.dataRegisto as dataFaturaIndividual',
                    'CoreFaturacaoAutomaticaEmpresa.documentoErp as numeroFaturaEmpresa',
                    'CoreFaturacaoAutomaticaEmpresa.dataRegisto as dataFaturaEmpresa',
                    // Consulta da fatura (CR-SLD20180014-0032)
                    'CoreFaturacaoAutomatica.ficheiroUuid as ficheiroFaturaIndividual',
                    'CoreFaturacaoAutomaticaEmpresa.ficheiroUuid as ficheiroFaturaEmpresa'
                ],
                from: ['FormacaoInscricao', 'CorePagamento', 'CoreFormaPagamento', 'FormacaoFormando', 'FormacaoInscricaoEstado', 'FormacaoEdicao', 'FormacaoCurso', 'FormacaoInscricaoEmpresa', 'FormacaoEmpresa', 'CoreFaturacaoAutomatica', 'CoreFaturacaoAutomatica'], // Edicao is used in table()
                referencesOrigin: [undefined, undefined, 'CoreFormaPagamento.id', undefined, undefined, undefined, 'FormacaoCurso.id', undefined, 'FormacaoEmpresa.id', 'CoreFaturacaoAutomatica.formacaoInscricaoId', 'CoreFaturacaoAutomaticaEmpresa.formacaoInscricaoEmpresaId'],
                references: [undefined, 'FormacaoInscricao.pagamentoId', 'CorePagamento.formaPagamentoId', 'FormacaoInscricao.formandoId', 'FormacaoInscricao.estadoId', 'FormacaoInscricao.edicaoId', 'FormacaoEdicao.cursoId', 'FormacaoInscricao.inscricaoEmpresaId', 'FormacaoInscricaoEmpresa.empresaId', 'FormacaoInscricao.id', 'FormacaoInscricao.inscricaoEmpresaId'],
                // `core_faturacao_automatica` entra duas vezes (A3 / CR-SLD20180014-0004): uma
                // pela FK da inscrição individual e outra, com alias, pela FK da inscrição de
                // empresa. Sem o alias o segundo LEFT JOIN repetiria o nome da tabela.
                aliases: [undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'CoreFaturacaoAutomaticaEmpresa'],
                where: whereFields.where,
                whereLiteral: whereFields.whereLiteral,
                whereDates: whereFields.whereDates,
                whereOr: whereFields.whereOr,
                whereOrLiteral: whereFields.whereOrLiteral,
                order: this.opt.order,
                sort: this.opt.sort,
                limit: this.opt.items,
                skip: (this.opt.page - 1) * this.opt.items,
            }
        }).$promise.then(res => {
            let page = this.opt.page;
            let items = this.opt.items;
            let total = res.count;
            this.start = total > 0 ? (page - 1) * items + 1 : 0;
            if ((this.start - 1 + items) >= total) {
                this.end = total;
            }
            else {
                this.end = Number.parseInt(this.start - 1 + items);
            }
            // Process output
            // res.data.forEach(r => {
            //   let tmp = r.tipo === "Metrologia" ? 'M' : 'E';
            //   r.processo = `${tmp}-${r.iidAno}-${("0000" + r.iidProc).slice(-4)}`;
            // });
            this.inscricoes = res.data;
            this.total = total;
            this.tableLoading = false;
        }).catch((e) => {
            this.tableLoading = false;
            console.log(e);
            this.UI.addToast("Não foi possível obter inscrições. Verifique a ligação e permissões");
        });
    };
    exportInscricoes = () => {
        let wait = this.UI.showWaiting();
        let whereFields = this.setWhereFields(this.customFilters);
        this.FormacaoInscricao.exportInscricoes({
            displayColumns: this.displayColumns,
            params: {
                fields: [
                    'FormacaoInscricao.id as id',
                    'FormacaoInscricao.edicaoId as edicaoId',
                    'FormacaoInscricao.estadoId as estadoId',
                    'FormacaoInscricao.dataInscricao as dataInscricao',
                    // 'edicao' comes by automatically (not declared here)
                    // Formando
                    'FormacaoFormando.nome as formandoNome',
                    'FormacaoFormando.nif as formandoNif',
                    'FormacaoFormando.email as formandoEmail',
                    'FormacaoFormando.telefone as formandoTelefone',
                    // Core Pagamento
                    'CorePagamento.referencia as referencia',
                    'CorePagamento.uid as uid',
                    'CorePagamento.pago as pago',
                    'CorePagamento.pagamentoData as dataPagamento',
                    'CorePagamento.valor as valor',
                    'CorePagamento.observacoes as observacoes',
                    // Empresa
                    'FormacaoEmpresa.designacao as empresa',
                    'FormacaoEmpresa.nif as empresaNif',
                    // Extras
                    'CoreFormaPagamento.designacao as formaPagamento',
                    'FormacaoInscricaoEstado.designacao as estado',
                    // Faturação (A3 / CR-SLD20180014-0004): duas origens porque o PEF liga-se
                    // à inscrição individual ou à inscrição de empresa; o `table()` junta-as
                    // em `numeroFatura`/`dataFatura`
                    'CoreFaturacaoAutomatica.documentoErp as numeroFaturaIndividual',
                    'CoreFaturacaoAutomatica.dataRegisto as dataFaturaIndividual',
                    'CoreFaturacaoAutomaticaEmpresa.documentoErp as numeroFaturaEmpresa',
                    'CoreFaturacaoAutomaticaEmpresa.dataRegisto as dataFaturaEmpresa'
                ],
                from: ['FormacaoInscricao', 'CorePagamento', 'CoreFormaPagamento', 'FormacaoFormando', 'FormacaoInscricaoEstado', 'FormacaoEdicao', 'FormacaoCurso', 'FormacaoInscricaoEmpresa', 'FormacaoEmpresa', 'CoreFaturacaoAutomatica', 'CoreFaturacaoAutomatica'], // Edicao is used in table()
                referencesOrigin: [undefined, undefined, 'CoreFormaPagamento.id', undefined, undefined, undefined, 'FormacaoCurso.id', undefined, 'FormacaoEmpresa.id', 'CoreFaturacaoAutomatica.formacaoInscricaoId', 'CoreFaturacaoAutomaticaEmpresa.formacaoInscricaoEmpresaId'],
                references: [undefined, 'FormacaoInscricao.pagamentoId', 'CorePagamento.formaPagamentoId', 'FormacaoInscricao.formandoId', 'FormacaoInscricao.estadoId', 'FormacaoInscricao.edicaoId', 'FormacaoEdicao.cursoId', 'FormacaoInscricao.inscricaoEmpresaId', 'FormacaoInscricaoEmpresa.empresaId', 'FormacaoInscricao.id', 'FormacaoInscricao.inscricaoEmpresaId'],
                // `core_faturacao_automatica` entra duas vezes (A3 / CR-SLD20180014-0004): uma
                // pela FK da inscrição individual e outra, com alias, pela FK da inscrição de
                // empresa. Sem o alias o segundo LEFT JOIN repetiria o nome da tabela.
                aliases: [undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'CoreFaturacaoAutomaticaEmpresa'],
                where: whereFields.where,
                whereLiteral: whereFields.whereLiteral,
                whereDates: whereFields.whereDates,
                whereOr: whereFields.whereOr,
                whereOrLiteral: whereFields.whereOrLiteral,
                order: this.opt.order,
                sort: this.opt.sort,
                // limit: this.opt.items,
                // skip: (this.opt.page - 1) * this.opt.items,
            }
        }).$promise.then(res => {
            if (res.count) {
                wait.close();
                let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + res.fileData;
                let b = document.createElement('a');
                b.href = url;
                b.download = 'inscricoesExportadas.xlsx';
                b.click();
            }
            else {
                this.UI.addToast("Nenhum resultado encontrado. A exportação foi cancelada.");
            }
        }).catch((e) => {
            wait.close();
            console.log(e);
            this.tableLoading = false;
            this.UI.addToast("Não foi possível exportar inscrições. Verifique a ligação.");
        });
    };
    exportSelected = () => {
        let wait = this.UI.showWaiting();
        let orsLiteral = [];
        // if a few processos selected only
        if (this.hasSelect() && !this.everythingSelected)
            orsLiteral = _.map(_.filter(this.inscricoes, x => x.selected), x => {
                return { key: 'FormacaoInscricao.id', value: x.id };
            });
        let whereFields = this.setWhereFields(this.customFilters, {}, orsLiteral);
        this.FormacaoInscricao.exportInscricoes({
            displayColumns: this.displayColumns,
            params: {
                fields: [
                    'FormacaoInscricao.id as id',
                    'FormacaoInscricao.edicaoId as edicaoId',
                    'FormacaoInscricao.estadoId as estadoId',
                    'FormacaoInscricao.dataInscricao as dataInscricao',
                    // 'edicao' comes by automatically (not declared here)
                    // Formando
                    'FormacaoFormando.nome as formandoNome',
                    'FormacaoFormando.nif as formandoNif',
                    'FormacaoFormando.email as formandoEmail',
                    'FormacaoFormando.telefone as formandoTelefone',
                    // Core Pagamento
                    'CorePagamento.referencia as referencia',
                    'CorePagamento.uid as uid',
                    'CorePagamento.pago as pago',
                    'CorePagamento.pagamentoData as dataPagamento',
                    'CorePagamento.valor as valor',
                    'CorePagamento.observacoes as observacoes',
                    // Empresa
                    'FormacaoEmpresa.designacao as empresa',
                    'FormacaoEmpresa.nif as empresaNif',
                    // Extras
                    'CoreFormaPagamento.designacao as formaPagamento',
                    'FormacaoInscricaoEstado.designacao as estado',
                    // Faturação (A3 / CR-SLD20180014-0004): duas origens porque o PEF liga-se
                    // à inscrição individual ou à inscrição de empresa; o `table()` junta-as
                    // em `numeroFatura`/`dataFatura`
                    'CoreFaturacaoAutomatica.documentoErp as numeroFaturaIndividual',
                    'CoreFaturacaoAutomatica.dataRegisto as dataFaturaIndividual',
                    'CoreFaturacaoAutomaticaEmpresa.documentoErp as numeroFaturaEmpresa',
                    'CoreFaturacaoAutomaticaEmpresa.dataRegisto as dataFaturaEmpresa'
                ],
                from: ['FormacaoInscricao', 'CorePagamento', 'CoreFormaPagamento', 'FormacaoFormando', 'FormacaoInscricaoEstado', 'FormacaoEdicao', 'FormacaoCurso', 'FormacaoInscricaoEmpresa', 'FormacaoEmpresa', 'CoreFaturacaoAutomatica', 'CoreFaturacaoAutomatica'], // Edicao is used in table()
                referencesOrigin: [undefined, undefined, 'CoreFormaPagamento.id', undefined, undefined, undefined, 'FormacaoCurso.id', undefined, 'FormacaoEmpresa.id', 'CoreFaturacaoAutomatica.formacaoInscricaoId', 'CoreFaturacaoAutomaticaEmpresa.formacaoInscricaoEmpresaId'],
                references: [undefined, 'FormacaoInscricao.pagamentoId', 'CorePagamento.formaPagamentoId', 'FormacaoInscricao.formandoId', 'FormacaoInscricao.estadoId', 'FormacaoInscricao.edicaoId', 'FormacaoEdicao.cursoId', 'FormacaoInscricao.inscricaoEmpresaId', 'FormacaoInscricaoEmpresa.empresaId', 'FormacaoInscricao.id', 'FormacaoInscricao.inscricaoEmpresaId'],
                // `core_faturacao_automatica` entra duas vezes (A3 / CR-SLD20180014-0004): uma
                // pela FK da inscrição individual e outra, com alias, pela FK da inscrição de
                // empresa. Sem o alias o segundo LEFT JOIN repetiria o nome da tabela.
                aliases: [undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'CoreFaturacaoAutomaticaEmpresa'],
                where: whereFields.where,
                whereLiteral: whereFields.whereLiteral,
                whereDates: whereFields.whereDates,
                whereOr: whereFields.whereOr,
                whereOrLiteral: whereFields.whereOrLiteral,
                order: this.opt.order,
                sort: this.opt.sort,
                // limit: this.opt.items,
                // skip: (this.opt.page - 1) * this.opt.items,
            }
        }).$promise.then(res => {
            if (res.count) {
                wait.close();
                let url = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + res.fileData;
                let b = document.createElement('a');
                b.href = url;
                b.download = 'inscricoesExportadas.xlsx';
                b.click();
            }
            else {
                this.UI.addToast("Nenhum resultado encontrado. A exportação foi cancelada.");
            }
        }).catch((e) => {
            wait.close();
            console.log(e);
            this.tableLoading = false;
            this.UI.addToast("Não foi possível exportar inscrições. Verifique a ligação.");
        });
    };
    // Consulta da fatura, só em leitura (CR-SLD20180014-0032): o PDF guardado pelo worker
    abrirFatura = (x) => {
        window.open(`/api/Upload/faturas_automaticas_for/download/${x.ficheiroFatura}.pdf`, '_blank');
    };
    isColumnVisible = (column) => {
        let f = this.displayColumns.find(x => x.name === column);
        return _.isEmpty(f) ? false : f.visible;
    };
    selectVisibleColumns = () => {
        let options = {
            size: 'md',
            template: require('./columns.dialog.html'),
            controller: ['$dialog', '$scope', (dialog, scope) => {
                    scope.title = "Editar Campos Visíveis";
                    scope.displayColumns = angular.copy(this.displayColumns);
                    scope.ok = () => {
                        dialog.close(scope);
                    };
                    scope.cancel = () => {
                        dialog.dismiss('cancel');
                    };
                }]
        };
        let modal = this.UI.showDialog(options);
        modal.then((res) => {
            if (res && res.displayColumns) {
                this.displayColumns = angular.copy(res.displayColumns);
                // Save it to local storage
                localStorage.setItem('FormacaoInscricoesDisplayColumns', JSON.stringify(this.displayColumns));
            }
        });
    };
    loadData = () => {
        this.FormacaoEdicao.find({
            filter: {
                fields: { id: true, cursoId: true, no: true, ano: true },
                where: {
                    active: true
                },
                include: {
                    relation: 'curso',
                    scope: {
                        fields: { id: true, designacao: true },
                    }
                },
                order: 'id DESC'
            }
        }).$promise.then(edicoes => {
            edicoes.forEach(e => {
                e.name = `(${e.no}/${e.ano}) ${e.curso.designacao}`;
            });
            this.edicoes = edicoes;
            this.filtersLoaded[1] = 1;
        }).catch(e => {
            console.log(e);
            this.edicoes = [];
            this.filtersLoaded[1] = 1;
            this.UI.addToast("Erro de carregamento de dados para filtragem (Edições).");
        });
        this.FormacaoInscricaoEstado.find({
            filter: {
                where: {},
                order: 'id ASC'
            }
        }).$promise.then(estadosInscricao => {
            estadosInscricao.forEach(t => {
                t.name = t.designacao;
            });
            this.estadosInscricao = estadosInscricao;
            this.filtersLoaded[2] = 1;
        }).catch(e => {
            console.log(e);
            this.estadosInscricao = [];
            this.filtersLoaded[2] = 1;
            this.UI.addToast("Erro de carregamento de dados para filtragem (Estados de Inscrição).");
        });
        this.CoreFormaPagamento.find({ filter: { where: { active: true }, order: 'id ASC' } }).$promise.then(formasPagamento => {
            formasPagamento.forEach(fp => {
                fp.name = fp.designacao;
            });
            this.formasPagamento = formasPagamento;
            this.filtersLoaded[3] = 1;
        }).catch(e => {
            console.log(e);
            this.formasPagamento = [];
            this.filtersLoaded[3] = 1;
            this.UI.addToast("Erro de carregamento de dados para filtragem (Formas Pagamento).");
        });
        this.FormacaoEmpresa.find({ filter: { where: { active: true } } }).$promise.then(empresas => {
            empresas.forEach(fp => {
                fp.name = fp.designacao;
            });
            this.empresas = empresas;
            this.filtersLoaded[4] = 1;
        }).catch(e => {
            console.log(e);
            this.empresas = [];
            this.filtersLoaded[4] = 1;
            this.UI.addToast("Erro de carregamento de dados para filtragem (Empresas).");
        });
    };
    sort = key => {
        if (!key.sortable) {
            return;
        }
        let keyname = key.name;
        if (this.opt.order === keyname)
            this.opt.page = 1;
        this.opt.order = keyname;
        this.opt.sort = this.opt.sort === 'asc' ? 'desc' : 'asc';
        this.$state.go('app.formacao.inscricoes.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getInscricoes();
    };
    item = val => {
        this.opt.items = val;
        this.$state.go('app.formacao.inscricoes.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getInscricoes();
    };
    page = sum => {
        this.opt.page += sum;
        if (this.opt.page < 1)
            this.opt.page = 1;
        if (this.opt.page > Math.ceil(this.total / this.opt.items))
            this.opt.page = Math.ceil(this.total / this.opt.items);
        this.$state.go('app.formacao.inscricoes.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getInscricoes();
    };
    openFilter = () => {
        let result = this.filtersLoaded.reduce((a, b) => a + b, 0);
        if (result !== this.filtersLoaded.length) {
            this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
            return;
        }
        if (!this.edicoes.length && !this.estadosInscricao.length && !this.formasPagamento.length) {
            this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
            return;
        }
        this.columns.forEach(f => {
            if (f.id === 'FormacaoInscricao.edicaoId')
                f.list = this.edicoes;
            if (f.id === 'FormacaoInscricao.estadoId')
                f.list = this.estadosInscricao;
            if (f.id === 'CorePagamento.pago')
                f.list = this.simnao;
            if (f.id === 'CorePagamento.formaPagamentoId')
                f.list = this.formasPagamento;
            if (f.id === 'FormacaoInscricaoEmpresa.empresaId')
                f.list = this.empresas;
        });
        // Copy column to be used in
        this.editColumns = angular.copy(this.columns);
        // Restore list to selected
        this.customFilters.forEach(f => {
            if (f.column && f.column.selected) {
                if (f.column.selected.id === 'FormacaoInscricao.edicaoId')
                    f.column.selected.list = this.edicoes;
                if (f.column.selected.id === 'FormacaoInscricao.estadoId')
                    f.column.selected.list = this.estadosInscricao;
                if (f.column.selected.id === 'CorePagamento.pago')
                    f.column.selected.list = this.simnao;
                if (f.column.selected.id === 'CorePagamento.formaPagamentoId')
                    f.column.selected.list = this.formasPagamento;
                if (f.column.selected.id === 'FormacaoInscricaoEmpresa.empresaId')
                    f.column.selected.list = this.empresas;
            }
        });
        // Copy customFilter to another variable so we can edit it all we want
        this.editCustomFilters = angular.copy(this.customFilters);
        // Show side panel
        this.fs = true;
    };
    oldColumn = ($item, i) => {
        //Infinite Scroll Magic
        i.infiniteScroll = {};
        i.infiniteScroll.numToAdd = 20;
        i.infiniteScroll.currentItems = 20;
        if ($item.type === 's')
            i.value = {};
        else
            i.value = "";
        i.addMoreItems = function () {
            i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
        };
    };
    applyFilter = () => {
        // Parse values from sidebar
        this.editCustomFilters = _.filter(this.editCustomFilters, f => f.column && !_.isEmpty(f.value));
        // Remove list for column, no need to save it
        this.editCustomFilters.forEach(f => {
            if (f.column && f.column.selected) {
                f.column.selected.list = [];
            }
            // Fix date filters to be moment()
            if (f.column.selected.type === 'd') {
                f.value = moment(f.value).utc();
                f.value.second(0); // We don't care about seconds
            }
        });
        this.customFilters = angular.copy(this.editCustomFilters);
        localStorage.setItem('FormacaoInscricoesFilter', JSON.stringify(this.customFilters));
        this.fs = false;
        // Go to first page for results
        this.opt.page = 1;
        this.$state.go('app.formacao.inscricoes.list', this.opt, {
            // prevent the events onStart and onSuccess from firing
            notify: false,
            // prevent reload of the current state
            reload: false,
            // replace the last record when changing the params so you don't hit the back button and get old params
            location: 'replace',
            // inherit the current params on the url
            inherit: true
        });
        this.getInscricoes();
    };
    hasSelect = () => {
        return _.some(this.inscricoes, a => a.selected === true);
    };
    selectAll = () => {
        if (this.allSelected) { // Not all are selected, select all
            this.inscricoes.forEach(a => {
                a.selected = true;
            });
            this.nSelected = this.inscricoes.length;
        }
        else { // Remove all selections
            this.inscricoes.forEach(a => {
                a.selected = false;
            });
            this.nSelected = 0;
        }
        this.everythingSelected = false;
    };
    selectEverything = (type) => {
        if (!type) {
            this.inscricoes.forEach(a => {
                a.selected = false;
            });
            this.nSelected = 0;
            this.allSelected = false;
        }
        this.everythingSelected = !!type;
    };
    selectItem = () => {
        this.nSelected = _.filter(this.inscricoes, r => r.selected).length;
        this.allSelected = this.nSelected >= this.inscricoes.length;
        this.everythingSelected = false;
    };
}
FormacaoInscricoesController.$inject = ['$q', '$filter', '$state', 'UIService', 'AuthenticationService', 'AuthorizationService', 'FormacaoInscricao', 'FormacaoEdicao', 'FormacaoInscricaoEstado', 'CoreFormaPagamento', 'FormacaoEmpresa'];
